<template>
  <div class="c-notify-container" :class="[className]">
    <transition name="mask">
      <div class="c-mask" v-show="hasMask && visible"></div>
    </transition>
    <transition name="dialog">
      <div class="notify-confirm" :class="[className]" v-if="visible">
        <div class="notify-hd" v-if="title !== ''">
          <span class="title">{{ title }}</span>
        </div>
        <div class="notify-bd" v-html="content"></div>
        <div class="notify-ft">
          <div class="cancel-btn" @click="onClose" v-if="cancelButton.text">
            {{ cancelButton.text }}
          </div>
          <div class="confirm-btn" @click="onConfirm" v-if="confirmButton.text">
            {{ confirmButton.text }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'notice',
  props: {
    hasMask: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    cancelButton: {
      type: Object,
      default: () => {
        return {
          text: '取消',
          callback: undefined,
        };
      },
    },
    confirmButton: {
      type: Object,
      default: () => {
        return {
          text: '确定',
          callback: undefined,
        };
      },
    },
    className: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    callback(name) {
      if (this[name] && typeof this[name].callback === 'function') {
        this[name].callback();
      }
    },
    close() {
      this.visible = false;
    },
    onClose() {
      this.callback('cancelButton');
      this.close();
    },
    onConfirm() {
      this.callback('confirmButton');
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'var';
.c-notify-container {
  .notify-alert,
  .notify-confirm {
    display: table;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 6rem;
    margin: auto;
    background: #ffffff;
    border-radius: 0.06rem;
    z-index: 1000;
  }
  .notify-hd {
    padding: 0.2rem 0.1rem 0;
    text-align: center;
    color: #333333;
    font-size: 0.32rem;
    .title {
      font-weight: 700;
    }
  }
  .notify-bd {
    padding: 0.2rem;
    min-height: 1rem;
    font-size: 0.3rem;
    color: #333333;
    text-align: center;
    word-break: break-all;
    word-wrap: break-word;
  }
  .notify-ft {
    display: flex;
    border-top: 0.02rem solid #e0e0e0;
    .confirm-btn,
    .cancel-btn {
      flex: 1;
      text-align: center;
      font-size: 0.32rem;
      color: #333333;
      padding: 0.2rem 0;
    }
    .cancel-btn + .confirm-btn {
      border-left: 0.02rem solid #e0e0e0;
    }
    .confirm-btn {
      color: #448ff2;
    }
  }
}
</style>
